var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { AccessDeniedMessageBox, CardHoldersErrors, ConfirmedUserAdded, EligibleMemberList, ExistingUser, UserFormSams, VerifyMessageBox } from '../main-container/components';
import { CardholdersScreen } from '../typings';
var displayModalScreen = function (screenType) {
    var _a;
    var modalScreenMap = (_a = {},
        _a[CardholdersScreen.ACCESS_DENIED_SCREEN] = _jsx(AccessDeniedMessageBox, {}),
        _a[CardholdersScreen.ADD_AUTH_USER] = null,
        _a[CardholdersScreen.ADD_AUTH_USER_SAMS] = _jsx(UserFormSams, {}),
        _a[CardholdersScreen.ADD_AUTH_USER_SAMS_LIST] = _jsx(EligibleMemberList, {}),
        _a[CardholdersScreen.CONFIRMATION_SCREEN_NEW_USER] = _jsx(ConfirmedUserAdded, {}),
        _a[CardholdersScreen.CONFIRMATION_SCREEN_EXISTING_USER] = _jsx(ExistingUser, {}),
        _a[CardholdersScreen.ERROR_SCREEN] = (_jsx(CardHoldersErrors, __assign({}, screenType.customData))),
        _a[CardholdersScreen.INITIAL_SCREEN] = null,
        _a[CardholdersScreen.VERIFY_USER_SCREEN] = _jsx(VerifyMessageBox, {}),
        _a);
    return modalScreenMap[screenType.screen] || null;
};
export default displayModalScreen;
